export const AVAILABLE_BALANCE_DATE_FORMAT = 'YYYY-MM-DD';